"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusIndicatorSize = exports.StatusIndicatorColorScheme = exports.Status = void 0;
var Status;
exports.Status = Status;

(function (Status) {
  Status["Positive"] = "positive";
  Status["Warning"] = "warning";
  Status["Negative"] = "negative";
  Status["Neutral"] = "neutral";
  Status["Information"] = "information";
  Status["Waiting"] = "waiting";
  Status["Unavailable"] = "unavailable";
  Status["Loading"] = "loading";
})(Status || (exports.Status = Status = {}));

var StatusIndicatorSize;
exports.StatusIndicatorSize = StatusIndicatorSize;

(function (StatusIndicatorSize) {
  StatusIndicatorSize["Small"] = "small";
  StatusIndicatorSize["Large"] = "large";
})(StatusIndicatorSize || (exports.StatusIndicatorSize = StatusIndicatorSize = {}));

var StatusIndicatorColorScheme;
exports.StatusIndicatorColorScheme = StatusIndicatorColorScheme;

(function (StatusIndicatorColorScheme) {
  StatusIndicatorColorScheme["Default"] = "default";
  StatusIndicatorColorScheme["Inverted"] = "inverted";
})(StatusIndicatorColorScheme || (exports.StatusIndicatorColorScheme = StatusIndicatorColorScheme = {}));